const config = {
    appName: 'CheeksAndLips',
    company: 'Zenboost OU',
    domain: 'cheeksandlips.com',
    regNum: '17053006',
    address: 'Harju county, Tallinn, Haaberst district,Paldiski street 199a, 13517',
    country: 'Estonia',
    mailTo: 'support@cheeksandlips.com',
    phone: '+372 6683213',
    descriptor:'cksndbill.com +372 6683213 cksndpay.com +372 6683213 cksndli.com +372 6683213 cheeksandlips Tallinn cheeksandlips.info +372 668 3213',

    nextPaymentDay: '3rd',
    nextPaymentDayTwo: '7th',
    rebillDaysPrice: '28',
    rebillPrice: '69.49',

    productTrialPrices: [1.95, 9.99],
    productRebillPrices: '69.49',
    productSubscriptionDays: [3, 7],
}

export default config
